import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { DownloadButton, PopupBlockedDialog } from "@packages/ui";
import { downloadDocument, viewDocument } from "../../utils/apiRequestBuilder";

const DownloadButtonGrid = ({ raNumber, fileName, fileLabel, originalFlag = false }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => ({ ...state.auth }));
  console.log("original flag", originalFlag);
  const onDownload = async () => {
    await downloadDocument({
      raNumber,
      fileName,
      auth,
      version: "1",
      dispatch,
    });

    // Also download the first signed file
    if (originalFlag) {
      await downloadDocument({
        raNumber,
        fileName,
        auth,
        version: "0",
        dispatch,
      });
    }
  };

  const [showPopupError, setShowPopupError] = useState(false);
  const onView = async (version = "1") => {
    const newWindow = await viewDocument({
      raNumber,
      fileName,
      auth,
      version: version,
      dispatch,
    });
    if (!newWindow) {
      setShowPopupError(true);
    }
  };

  return (
    <>
      <Grid item>
        <DownloadButton
          color="yellow"
          type="button"
          title={`View Latest ${fileLabel}`}
          onClick={onView}
        />
        {showPopupError && <PopupBlockedDialog onCloseAction={() => setShowPopupError(false)} />}
      </Grid>
      <Grid item>
        {originalFlag && (
          <DownloadButton
            color="yellow"
            type="button"
            title={`View Original ${fileLabel}`}
            onClick={() => onView("0")}
          />
        )}
      </Grid>
      <Grid item>
        <DownloadButton
          color="yellow"
          type="button"
          title={originalFlag ? `Download Both ${fileLabel}s` : `Download ${fileLabel}`}
          onClick={onDownload}
        />
      </Grid>
    </>
  );
};

DownloadButtonGrid.propTypes = {
  raNumber: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileLabel: PropTypes.string,
};

DownloadButtonGrid.defaultProps = {
  fileLabel: "Document",
};

export default DownloadButtonGrid;
